<template>
  <div>
    <!-- <img class="home-background__image--overlay" :src="backgroundImage" alt=""> -->
    <div class="home-background__color--overlay"></div>
    <particles class="home-gradient">
      <home-toolbar></home-toolbar>

      <div class="content text-xs-center hide-on-hover">
        <v-container fluid grid-list-lg>
          <v-layout row wrap justify-center align-center>
            <v-flex md6 xs12>
              <div data-aos="zoom-in" data-aos-easing="ease">
                <carousel
                  :autoplayTimeout="3000"
                  :paginationEnabled="false"
                  :perPage="1"
                  autoplay
                  loop
                  paginationActiveColor="rgba(33, 208, 166, 0.25)"
                  paginationColor="rgba(255, 255, 255, 0.16)"
                  >
                  <template
                    v-for="(item, i) in carousel.items"
                    >
                    <slide :key="i">
                      <h1 class="display-2">
                        <strong v-html="item.title"></strong>
                      </h1>
                    </slide>
                  </template>
                </carousel>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <div class="hidden-sm-and-down">
        <grid-layout-web></grid-layout-web>
      </div>
      <div class="hidden-md-and-up">
        <grid-layout-mobile></grid-layout-mobile>
      </div>
    </particles>
  </div>
</template>

<style lang="stylus" scoped>
.hide-on-hover {
  transition: all 0.3s ease-in-out;

  &--active {
    opacity: 0;
  }
}
</style>

<script>
import store from '@/store'
import { Carousel, Slide } from 'vue-carousel'
import LogoIcon from '@/components/Icons/LogoIcon'
import GridLayoutWeb from './partials/GridLayoutWeb'
import GridLayoutMobile from './partials/GridLayoutMobile'
import backgroundImage from '@/modules/CDA/Home/assets/images/bg.jpg'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  store,

  name: 'Home',

  components: {
    Carousel,
    Slide,
    LogoIcon,
    GridLayoutWeb,
    GridLayoutMobile,
    AOS,
  },

  mounted () {
    setTimeout(function () {
      AOS.init()
    }, 400)
  },

  data () {
    return {
      backgroundImage: backgroundImage,
      carousel: {
        items: [
          { title: 'Cyber Defence Academy' },
          { title: 'Build Capabilities to be Cyber Resilient' },
          { title: 'Measure Cybersecurity Performance' },
          { title: 'Protect Digital Assets through Cybersecurity Resilience' },
          { title: 'Comply with Cybersecurity legislation' },
          { title: 'Create Robust Cybersecurity Governance, Risk & Compliance Framework' },
        ]
      }
    }
  }
}
</script>
